export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['center', 'minTopPadding'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter', 'endMargin'],
                component1: {
                  type: 'header-full',
                  data: {
                    blockModifiers: ['noPadding', 'mediumWeight', 'smallerFontSize'],
                    text: 'Spotin Commerce Manager.',
                    textMobile: 'Spotin Commerce Manager.',
                    subText: 'The ideal publisher tool to create curated shopping experiences and to make any content shoppable'
                  }
                },
                component3: {
                  type: 'animation',
                  data: {
                    // blockModifiers: ['mobileNegativeYOffset'],
                    loop: true,
                    autoplay: true,
                    src: "Commerce_manager_header.json",
                  }
                }
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header1: 'Manage all commerce in your content, and in your shop',
                text2: "<p>With the Commerce Manager you can create and manage all commercial solutions with Spotin directly on your site. Add embedded on-site shopping solutions and manage your shop with an easy to use UI.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        // blockModifiers: ['noMobilePaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                // ,'noColumnMargin'
                blockModifiers: ['alignCenter', 'endMargin', 'mobileReverseColumn'],
                columns: 3,
                component1: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "ContentManager.json",
                    caption: "Spotin’s Commerce Manager, an intuitive UI integrated into your site’s content"
                  }
                },
                header3: 'An easy-to-use UI. Within your content',
                text3: "<p>With Spotin's Commerce Manager you as a Publisher can add commerce capabilities to your content with the click of a button.</p><p>Sign in to the Commerce Manager from your content. Use the Commerce Manager to manage your Shop, add commerce to existing content, or create commercial content with the build-in templates.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                // 'noColumnMargin',
                blockModifiers: ['alignCenter','endMargin'],
                header1: 'Add Spots, Buy Buttons or embed Shoppable Blocks',
                text1: "<p>Easily tag products featured within your content by using the Commerce Manager's intuitive UI.</p><p>Add Spotin’s Buy Buttons and Spots, or effortlessly incorporate curated lists into your content. All commerce solutions automatically stays up to date with seller's prices and product availability.</p>",
                component3: {
                  type: 'animation',
                  data: {
                    // blockModifiers: ['450px'],
                    loop: true,
                    autoplay: true,
                    src: "Add_in_commercemanager.json",
                    caption: "Example of Spotins Buy Buttons, Spots & Shoppable blocks"
                  }
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                // ,'noColumnMargin'
                blockModifiers: ['alignCenter','mobileReverseColumn','endMargin'],
                // columns: 3,
                component1: {
                  type: 'animation',
                  data: {
                    // blockModifiers: ['450px'],
                    loop: true,
                    autoplay: true,
                    src: "ShopReel.json",
                    caption: "Build your Spotin Shop in the Commerce Manager"
                  }
                },
                header3: 'Manage your own curated (and branded) shop',
                text3: "<p>With the Commerce Manager you can personalise the storefront of your shop to align with your audience’s preferences. The look and feel of the shop can also be adapted to match the Publisher's brand.</p><p>Select and showcase editor’s favourites from your catalog of sellers or enable the automatic creation and highlighting of a product selection with the best offers or current campaigns.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter','noColumnMargin','endMargin'],
                header1: 'Sellers\' full catalogue, always the latest, and current prices',
                text1: "<p>With the Commerce Manager Publishers can add commercialize content leveraging the entire product catalog from sellers.</p><p>All product information, images, stock levels, and prices (in different currencies) is always up-to-date from the sellers accross warehouses and markets. With live update of stock quantities on SKU level ensuring that customers knows when somethign is running out or sold out.</p>",
                component3: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['height300px'],
                    loop: true,
                    autoplay: true,
                    src: "Catalogue.json",
                    // caption: "Example of Spotins Buy Buttons, Spots & Shoppable blocks"
                  }
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter','mobileReverseColumn'],
                component1: {
                  type: 'animation',
                  data: {
                    // blockModifiers: ['450px'],
                    loop: true,
                    autoplay: true,
                    src: "Shop_this_buttons.json",
                    caption: "With Spotin, anything can be made shoppable."
                  }
                },
                header3: 'Combine with your own custom solutions',
                text3: "<p>Looking to smoothly integrate shoppable elements within your design?</p><p>Use Spotin Product or Shop Links, or use Spotin’s frontend API calls to create your own custom buttons, or connect menues or other parts of your site with Spotin’s commerce solutions.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Related'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin Portal',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'portal',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'What is content commerce',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'contentcommerce',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Commercemanager.js